// Browser-compatible URL encoding/decoding utility for forum IDs
// Using base64 encoding with URL-safe characters

export const encodeForumId = (forumId) => {
  try {
    console.log('🔐 Encoding forum ID:', forumId);
    
    // Convert to string and encode with base64
    const encoded = btoa(forumId.toString());
    console.log('🔧 Base64 encoded:', encoded);
    
    // Make it URL-safe by replacing characters
    const urlSafe = encoded.replace(/[+/=]/g, (match) => {
      switch (match) {
        case '+': return '-';
        case '/': return '_';
        case '=': return '';
        default: return match;
      }
    });
    
    console.log('✅ URL-safe encoded:', urlSafe);
    return urlSafe;
  } catch (error) {
    console.error('❌ Encoding error:', error, 'for input:', forumId);
    return forumId.toString();
  }
};

export const decodeForumId = (encodedId) => {
  try {
    console.log('🔓 Attempting to decode:', encodedId);
    
    // Convert back from URL-safe base64
    const padded = encodedId.replace(/[-_]/g, (match) => {
      switch (match) {
        case '-': return '+';
        case '_': return '/';
        default: return match;
      }
    });
    
    console.log('🔧 Padded string:', padded);
    
    // Add padding if needed
    const paddingNeeded = 4 - (padded.length % 4);
    const finalPadded = paddingNeeded < 4 ? padded + '='.repeat(paddingNeeded) : padded;
    
    console.log('🔧 Final padded string:', finalPadded);
    
    // Decode from base64
    const decoded = atob(finalPadded);
    console.log('🔧 Decoded string:', decoded);
    
    const result = parseInt(decoded);
    console.log('✅ Final result:', result);
    
    return result;
  } catch (error) {
    console.error('❌ Decoding error:', error, 'for input:', encodedId);
    return null;
  }
};

// Alternative simple obfuscation method
export const obfuscateForumId = (forumId) => {
  try {
    // Simple XOR obfuscation with a key
    const key = 0x5A5A5A5A; // Simple key
    const obfuscated = (parseInt(forumId) ^ key).toString(36);
    return obfuscated;
  } catch (error) {
    console.error('Obfuscation error:', error);
    return forumId.toString();
  }
};

export const deobfuscateForumId = (obfuscatedId) => {
  try {
    const key = 0x5A5A5A5A; // Same key
    const deobfuscated = parseInt(obfuscatedId, 36) ^ key;
    return deobfuscated;
  } catch (error) {
    console.error('Deobfuscation error:', error);
    return null;
  }
};
